import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cb6f1512&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=cb6f1512&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6f1512",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\haima\\mer_mer_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb6f1512')) {
      api.createRecord('cb6f1512', component.options)
    } else {
      api.reload('cb6f1512', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=cb6f1512&scoped=true", function () {
      api.rerender('cb6f1512', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/couponList/index.vue"
export default component.exports